import { extractFormData, parseHTMLSection } from "./CartUtils";
import CartAPI from "./CartAPI";
import SideCart from "./SideCart";

class MainCart extends HTMLElement {
    sidecart = document.querySelector<SideCart>('side-cart');
    private cartAPI;

    constructor() {
        super();
        this.cartAPI = CartAPI;
        this.init();
    }

    /**
     * Initializes the side cart by setting up events.
     */
    private init(): void {
        this.setupEventListeners();
        console.info('Main initialized');
    }

    /**
     * Sets up event listeners for the side cart.
     */
    private setupEventListeners(): void {
        this.initializeRemoveEvent();
        this.initializeUpdateEvent();
    }

    updateCart (itemCount:number) {
        const sectionId = this.dataset.sectionId
        try {
            fetch(`/cart?sections=main-cart&section_id=${sectionId}`, {
                method: 'GET',
                headers: {
                    contentType: 'application/json'
                }
            })
            .then(response => response.json())
            .then(responseJson => {
                this.renderNewCart(responseJson['main-cart'], itemCount)
            });
        } catch (error) {
            
        }
    }


    /**
     * Initializes the remove-from-cart event.
     */
    private initializeRemoveEvent(): void {
        const buttons = this.querySelectorAll('.side-cart-item__remove');
        buttons.forEach((button) => {
            button.addEventListener('click', async (evt) => {
                evt.preventDefault();
                console.info('Remove from cart clicked');
                const item = button.getAttribute('data-line-item');
                const formData = {
                    id: item,
                    quantity: 0,
                    sections: 'main-cart,ajax-side-cart,ajax-cart-icon'
                };
                if (formData) {
                    try {
                        const result = await this.cartAPI.removeFromCart(formData);
                        console.info('Item removed from cart:', result);
                        const sections = result['sections'];
                        const itemsCount = result['item_count'];
                        this.renderHTML(sections, itemsCount);
                    } catch (error) {
                        console.error('Failed to remove item from cart:', error);
                    }
                }
            });
        });
    }

    /**
     * Initializes the update cart item event.
     */
    private initializeUpdateEvent(): void {
        const inputs = this.querySelectorAll('.side-cart-item__quantity-input');
        inputs.forEach((input) => {
            const inputElement = input as HTMLInputElement;
            inputElement.addEventListener('change', async (evt) => {
                evt.preventDefault();
                console.info('Update cart item');
                const item = inputElement.getAttribute('data-line-item');
                const formData = {
                    id: item,
                    quantity: inputElement.value,
                    sections: 'main-cart,ajax-side-cart,ajax-cart-icon'
                };
                if (formData) {
                    try {
                        const result = await this.cartAPI.updateItemCart(formData);
                        console.info('Cart item updated:', result);
                        const sections = result['sections'];
                        const itemsCount = result['item_count'];
                        this.renderHTML(sections, itemsCount);
                    } catch (error) {
                        console.error('Failed to update cart item:', error);
                    }
                }
            });
        });
    }

    private renderNewCart(newCart:any, itemCount:number) {
        const newMainCart = parseHTMLSection(newCart)
        const mainCart = document.querySelector('main-cart')
        const cartItems = document.querySelector('.main-cart__items') || document.createElement('div')
        const subtotal = document.querySelector('.main-cart__subtotal') || document.createElement('div')
        const checkoutButtons = document.querySelector('.main-cart__buttons') || document.createElement('div')

        if(!mainCart) {
            console.error("Main Cart is not found.")
            return
        }

        cartItems.innerHTML = newMainCart.querySelector('.main-cart__items')?.innerHTML || ''
        subtotal.innerHTML = newMainCart.querySelector('.main-cart__subtotal')?.innerHTML || ''
        checkoutButtons.innerHTML = newMainCart.querySelector('.main-cart__buttons')?.innerHTML || ''

        if (itemCount == 0) {
            mainCart.querySelector('.main-cart__express-checkout')?.classList.add('visually-hidden')
        }
    }

    /**
     * Called when the element is added to the DOM.
     */
    private renderHTML(sections: any, itemCount: number): void {
        const HTMLSection = parseHTMLSection(sections['ajax-side-cart']);
        const sideCart = document.querySelector('side-cart');

        if (!sideCart) {
            console.error('No se encontró el elemento "side-cart".');
            return;
        }

        sideCart.innerHTML = '';
        sideCart?.appendChild(HTMLSection);
        
        this.initializeUpdateEvent();
        this.initializeRemoveEvent();

        const newCartIcon = parseHTMLSection(sections['ajax-cart-icon']);
        const cartIcon = document.querySelector('#side-cart-button');

        if (!cartIcon) {
            console.error('No se encontró el elemento "cart-icon".');
            return;
        }

        cartIcon.innerHTML = '';
        cartIcon?.appendChild(newCartIcon);

        this.renderNewCart(sections['main-cart'], itemCount)

        console.info('Cart updated.');

        this.sidecart?.setupEventListeners()
        this.setupEventListeners()
        return;
    }
}

export default MainCart;
